import { render } from "./PurchaseReceptionsMac.vue?vue&type=template&id=9cc7ada0&scoped=true&ts=true&lang=pug"
import script from "./PurchaseReceptionsMac.vue?vue&type=script&lang=ts"
export * from "./PurchaseReceptionsMac.vue?vue&type=script&lang=ts"

import "./PurchaseReceptionsMac.vue?vue&type=style&index=0&id=9cc7ada0&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cc7ada0"]])

export default __exports__